import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
} from "reactstrap"
import Performance from "./Performance"
import Analytics from "./Analytics"
import TopPerformers from "./TopPerformers"
import { Link } from "react-router-dom"

import classNames from "classnames"

//import Charts

//import action
import { getChartsData as onGetChartsData } from "../../store/actions"

import modalimage1 from "../../assets/images/product/img-7.png"
import modalimage2 from "../../assets/images/product/img-4.png"

// Pages Components

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useSelector, useDispatch } from "react-redux"
import { getAllRoles } from "../../store/roles/actions"
import { getAllPermissions } from "store/permissions/actions"
import { getDashboardStats } from "helpers/repository"
import { info } from "toastr"
import axios from "axios";
import {API_URL, sitename} from "../../constants/constants";
const Dashboard = props => {
  const dispatch = useDispatch()

  let tempDayNamearray = [],tempSalesNamearray = [],tempPayoutarray = [],tempGgrarray = [],tempTicketarray=[];
  const [stats, setStats] = useState(null)
  const [texReport, setTexReport] = useState()
  const [seriesData, setSeriesData] = useState([])
  const [optionData, setOptionsData] = useState({})

  let series=[];
  let options={};

  useEffect(() => {
    getDashboardStats(successCallback, errorCallback)
  }, [])

  const successCallback = res => {
    setStats(res.data)
  }
  const errorCallback = () => {
    console.log("error")
  }
  useEffect(() => {
    dispatch(getAllRoles())
    dispatch(getAllPermissions())
  }, [])

  useEffect(async () => {
    if (!texReport) {
      let reportsData=[];
      const response = await axios.get(`${API_URL}/admin/reports/ggr-reports?seven_day_formate=true`);
      setTexReport(response?.data?.data);
      reportsData = response?.data?.data;

      reportsData.map(report => {
        tempDayNamearray.push(report.day_name);
        tempGgrarray.push(report.ggr.toFixed(2));
        tempPayoutarray.push(report.payout.toFixed(2));
        tempSalesNamearray.push(report.total_stake.toFixed(2));
        tempTicketarray.push(report.total_ticket.toFixed(2));
      });

      series = [
        {
          name: "Sales",
          data: tempSalesNamearray,
        },
        {
          name: "Payout",
          data: tempPayoutarray,
        },
        {
          name: "GGR",
          data: tempGgrarray,
        },
        {
          name: "Tickets",
          data: tempTicketarray,
        },
      ];

      options = {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: false,
          },
        },
        colors: ["#00FF00", "#556ee6", "#f1b44c", "#FF0000"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        xaxis: {
          categories: tempDayNamearray,
        },

        markers: {
          size: 3,
          strokeWidth: 3,

          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
      }
      setSeriesData(series);
      setOptionsData(options);

    }
  }, [texReport]);

  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{sitename}</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
                title={props.t("Home")}
                breadcrumbItem={props.t("Dashboard")}
            />

            <Row>
              <Col xl="12">
                <Row>
                  <Col md="3">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <p className="text-muted fw-medium">Total Sales</p>
                            <h4 className="mb-0">{Number(stats?.total_sales.toFixed(2)).toLocaleString('en-GB')}</h4>
                          </Media>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i className={"bx bx-trending-up font-size-24"}></i>
                          </span>
                          </div>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="3" key={"_col_2"}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <p className="text-muted fw-medium">Total Tickets</p>
                            <h4 className="mb-0">{Number(stats?.total_tickets).toLocaleString('en-GB')}</h4>
                          </Media>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i className={"bx bx-task font-size-24"}></i>
                          </span>
                          </div>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="3" key={"_col_3"}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <p className="text-muted fw-medium">Total Users</p>
                            <h4 className="mb-0">{Number(stats?.total_users).toLocaleString('en-GB')}</h4>
                          </Media>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i className={"bx bx-user-circle font-size-24"}></i>
                          </span>
                          </div>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="3" key={"_col_4"}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <p className="text-muted fw-medium">Payouts</p>
                            <h4 className="mb-0">{Number(stats?.payout.toFixed(2)).toLocaleString('en-GB')}</h4>
                          </Media>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i
                                className={"bx bxs-check-square font-size-24"}
                            ></i>
                          </span>
                          </div>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl="12">

                {

                  <Performance options={optionData} series={seriesData} />

                }

              </Col>
            </Row>
            {/* <Row>
            <Col xl="12">
              <Analytics />
            </Col>
          </Row> */}
            <Row>
              <Col lg="12">
                <TopPerformers />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  )
}

export default withTranslation()(Dashboard)
